import {Box, Flex, Image, Text} from '@chakra-ui/react'

const Format2 = ({
  data,
  textData,
  isRecoding,
}: {
  data: any
  textData: any
  isRecoding: any
}) => {
  return (
    <Box flex={1} bg={'#1F1F1F'}>
      <Box
        className="container-xl"
        bgImage={data?.background_image}
        h={'100%'}
        bgSize={'cover'}>
        <Box position={'relative'} h={'100%'}>
          <Image
            h={'80%'}
            src={data?.avatar}
            position={'absolute'}
            bottom={0}
            left={'50%'}
            transform={'translateX(-50%)'}
          />
          <Flex
            className="video-title"
            position={'absolute'}
            top={0}
            p={'24px 60px'}
            w={'100%'}
            h={'200px'}
            color={'white'}
            flexDirection={'column'}
            bg={
              'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.20) 31.45%, rgba(0, 0, 0, 0.00) 56.13%)'
            }>
            <Text
              fontSize={'16px'}
              fontWeight={600}
              textTransform={'uppercase'}
              textShadow={'2px 2px 4px rgba(0, 0, 0, 0.5)'}>
              {'Tình huống'}
            </Text>
            <Text
              fontSize={'24px'}
              fontWeight={600}
              textShadow={'2px 2px 4px rgba(0, 0, 0, 0.5)'}>
              {data?.situation_name}
            </Text>
          </Flex>
          <Flex
            p={{base: 0, md: '24px 60px'}}
            position={'absolute'}
            zIndex={10}
            bottom={0}
            w={'100%'}
            flexDirection={'column'}
            bg={
              'linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.20) 31.45%, rgba(0, 0, 0, 0.00) 56.13%)'
            }>
            <Box
              w={'fit-content'}
              maxW={'90%'}
              mx={'auto'}
              p={'16px'}
              mb={'24px'}
              borderRadius={'16px'}
              bg={textData?.type === 'BOT' ? 'rgba(0, 0, 0, 0.6)' : '#F2F4F9'}
              backdropBlur={'4px'}>
              {isRecoding || !textData ? (
                <Box className="loading-message"></Box>
              ) : (
                <>
                  <Text
                    textAlign={'center'}
                    fontSize={'16px'}
                    fontWeight={600}
                    color={textData?.type === 'BOT' ? 'white' : '#999999'}>
                    {textData?.text_en || '...'}
                  </Text>
                  {textData?.type === 'BOT' && (
                    <Text
                      color={'rgba(255, 255, 255, 0.63)'}
                      textAlign={'center'}
                      fontSize={'16px'}>
                      {textData?.text_vi}
                    </Text>
                  )}
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}

export default Format2
